<div class="container mt-4">
  <div class="row">
    <div class="col-12">
      <!-- Page Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2>SignalR Real-time Demo</h2>
          <p class="text-muted mb-0">Test real-time messaging and notifications</p>
        </div>
        <div class="btn-group">
          <button class="btn btn-outline-primary" (click)="toggleAutoGeneration()">
            <i class="fas" [class.fa-play]="!autoGenerateMessages" [class.fa-pause]="autoGenerateMessages"></i>
            {{ autoGenerateMessages ? 'Stop' : 'Start' }} Auto Demo
          </button>
          <button class="btn btn-outline-danger" (click)="clearAllData()">
            <i class="fas fa-trash me-1"></i>
            Clear All
          </button>
        </div>
      </div>

      <!-- SignalR Status -->
      <div class="row mb-4">
        <div class="col-12">
          <app-signalr-status [showDetails]="true" [showMessageLog]="false"></app-signalr-status>
        </div>
      </div>

      <!-- Statistics Dashboard -->
      <div class="row mb-4">
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-primary">
            <div class="card-body">
              <i class="fas fa-envelope fa-2x text-primary mb-2"></i>
              <h3 class="text-primary">{{ stats.totalMessages }}</h3>
              <p class="card-text">Total Messages</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-info">
            <div class="card-body">
              <i class="fas fa-bell fa-2x text-info mb-2"></i>
              <h3 class="text-info">{{ stats.notifications }}</h3>
              <p class="card-text">
                Notifications
                <span class="badge bg-warning ms-1" *ngIf="stats.unreadNotifications > 0">
                  {{ stats.unreadNotifications }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-success">
            <div class="card-body">
              <i class="fas fa-box fa-2x text-success mb-2"></i>
              <h3 class="text-success">{{ stats.orderUpdates }}</h3>
              <p class="card-text">Order Updates</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-warning">
            <div class="card-body">
              <i class="fas fa-exclamation-triangle fa-2x text-warning mb-2"></i>
              <h3 class="text-warning">{{ stats.systemAlerts }}</h3>
              <p class="card-text">
                System Alerts
                <span class="badge bg-danger ms-1" *ngIf="stats.unacknowledgedAlerts > 0">
                  {{ stats.unacknowledgedAlerts }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Message Composition -->
      <div class="row mb-4">
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-paper-plane me-2"></i>
                Send Custom Message
              </h5>
            </div>
            <div class="card-body">
              <form (ngSubmit)="sendCustomMessage()" #messageForm="ngForm">
                <div class="mb-3">
                  <label class="form-label">Message Type</label>
                  <select class="form-select" [(ngModel)]="newMessage.type" name="type" required>
                    <option *ngFor="let type of messageTypes" [value]="type.value">
                      {{ type.label }}
                    </option>
                  </select>
                </div>
                
                <div class="mb-3">
                  <label class="form-label">Title</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    [(ngModel)]="newMessage.title" 
                    name="title"
                    placeholder="Enter message title"
                    required>
                </div>
                
                <div class="mb-3">
                  <label class="form-label">Content</label>
                  <textarea 
                    class="form-control" 
                    rows="3"
                    [(ngModel)]="newMessage.content" 
                    name="content"
                    placeholder="Enter message content"
                    required></textarea>
                </div>
                
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Target User (Optional)</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        [(ngModel)]="newMessage.targetUser" 
                        name="targetUser"
                        placeholder="Username">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Target Group (Optional)</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        [(ngModel)]="newMessage.targetGroup" 
                        name="targetGroup"
                        placeholder="Group name">
                    </div>
                  </div>
                </div>
                
                <button 
                  type="submit" 
                  class="btn btn-primary"
                  [disabled]="!messageForm.form.valid">
                  <i class="fas fa-send me-1"></i>
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
        
        <!-- Demo Controls -->
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-tools me-2"></i>
                Demo Controls
              </h5>
            </div>
            <div class="card-body">
              <!-- Auto Generation Settings -->
              <div class="mb-4">
                <div class="form-check mb-2">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="autoGenerate"
                    [(ngModel)]="autoGenerateMessages"
                    (change)="toggleAutoGeneration()">
                  <label class="form-check-label" for="autoGenerate">
                    Auto-generate demo messages
                  </label>
                </div>
                
                <div class="mb-3" *ngIf="autoGenerateMessages">
                  <label class="form-label">Interval (seconds)</label>
                  <select 
                    class="form-select form-select-sm" 
                    [(ngModel)]="messageInterval"
                    (ngModelChange)="autoGenerateMessages && startAutoGeneration()">
                    <option [value]="2000">2 seconds</option>
                    <option [value]="5000">5 seconds</option>
                    <option [value]="10000">10 seconds</option>
                    <option [value]="30000">30 seconds</option>
                  </select>
                </div>
              </div>
              
              <!-- Manual Generation -->
              <div class="mb-3">
                <h6>Generate Test Messages:</h6>
                <div class="btn-group-vertical w-100">
                  <button class="btn btn-outline-info btn-sm mb-1" (click)="generateRandomNotification()">
                    <i class="fas fa-bell me-1"></i>
                    Random Notification
                  </button>
                  <button class="btn btn-outline-primary btn-sm mb-1" (click)="generateRandomOrderUpdate()">
                    <i class="fas fa-box me-1"></i>
                    Random Order Update
                  </button>
                  <button class="btn btn-outline-warning btn-sm" (click)="generateRandomSystemAlert()">
                    <i class="fas fa-exclamation-triangle me-1"></i>
                    Random System Alert
                  </button>
                </div>
              </div>
              
              <!-- Clear Actions -->
              <div>
                <h6>Clear Data:</h6>
                <div class="btn-group w-100">
                  <button class="btn btn-outline-secondary btn-sm" (click)="clearNotifications()">
                    <i class="fas fa-bell"></i>
                  </button>
                  <button class="btn btn-outline-secondary btn-sm" (click)="clearOrderUpdates()">
                    <i class="fas fa-box"></i>
                  </button>
                  <button class="btn btn-outline-secondary btn-sm" (click)="clearSystemAlerts()">
                    <i class="fas fa-exclamation-triangle"></i>
                  </button>
                  <button class="btn btn-outline-danger btn-sm" (click)="clearAllData()">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Data Displays -->
      <div class="row">
        <!-- Notifications -->
        <div class="col-lg-4 mb-4">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-bell me-2"></i>
                Notifications
              </h6>
              <div>
                <span class="badge bg-primary me-1">{{ notifications.length }}</span>
                <button class="btn btn-outline-danger btn-sm" (click)="clearNotifications()" *ngIf="notifications.length > 0">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="notification-list" *ngIf="notifications.length > 0">
                <div 
                  class="notification-item p-3 border-bottom"
                  [class.unread]="!notification.read"
                  *ngFor="let notification of notifications.slice(0, 10)"
                  (click)="markNotificationAsRead(notification)">
                  
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h6 class="fw-bold mb-0">{{ notification.title }}</h6>
                    <small class="text-muted">{{ formatTimestamp(notification.timestamp) }}</small>
                  </div>
                  
                  <p class="mb-2 text-muted">{{ notification.message }}</p>
                  
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="badge" [class]="'bg-' + notification.type">{{ notification.type }}</span>
                    <small class="text-muted">{{ formatRelativeTime(notification.timestamp) }}</small>
                  </div>
                </div>
              </div>
              
              <div class="text-center p-4 text-muted" *ngIf="notifications.length === 0">
                <i class="fas fa-bell-slash fa-2x mb-2"></i>
                <p class="mb-0">No notifications yet</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Order Updates -->
        <div class="col-lg-4 mb-4">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-box me-2"></i>
                Order Updates
              </h6>
              <div>
                <span class="badge bg-primary me-1">{{ orderUpdates.length }}</span>
                <button class="btn btn-outline-danger btn-sm" (click)="clearOrderUpdates()" *ngIf="orderUpdates.length > 0">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="order-list" *ngIf="orderUpdates.length > 0">
                <div 
                  class="order-item p-3 border-bottom"
                  *ngFor="let order of orderUpdates.slice(0, 10)">
                  
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h6 class="fw-bold mb-0">{{ order.orderId }}</h6>
                    <small class="text-muted">{{ formatTimestamp(order.timestamp) }}</small>
                  </div>
                  
                  <p class="mb-2 text-muted">Status: <span class="fw-semibold">{{ order.status }}</span></p>
                  
                  <div class="progress mb-2" style="height: 6px;">
                    <div 
                      class="progress-bar" 
                      [class]="getProgressBarClass(order.progress)"
                      [style.width.%]="order.progress">
                    </div>
                  </div>
                  
                  <div class="d-flex justify-content-between align-items-center">
                    <small class="text-muted" *ngIf="order.location">
                      <i class="fas fa-map-marker-alt me-1"></i>
                      {{ order.location }}
                    </small>
                    <small class="text-muted">{{ order.progress }}% complete</small>
                  </div>
                </div>
              </div>
              
              <div class="text-center p-4 text-muted" *ngIf="orderUpdates.length === 0">
                <i class="fas fa-box-open fa-2x mb-2"></i>
                <p class="mb-0">No order updates yet</p>
              </div>
            </div>
          </div>
        </div>

        <!-- System Alerts -->
        <div class="col-lg-4 mb-4">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-exclamation-triangle me-2"></i>
                System Alerts
              </h6>
              <div>
                <span class="badge bg-primary me-1">{{ systemAlerts.length }}</span>
                <button class="btn btn-outline-danger btn-sm" (click)="clearSystemAlerts()" *ngIf="systemAlerts.length > 0">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="alert-list" *ngIf="systemAlerts.length > 0">
                <div 
                  class="alert-item p-3 border-bottom"
                  [class.unacknowledged]="!alert.acknowledged"
                  *ngFor="let alert of systemAlerts.slice(0, 10)"
                  (click)="acknowledgeAlert(alert)">
                  
                  <div class="alert mb-2" [class]="getAlertClass(alert.level)">
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="flex-grow-1">
                        <p class="mb-1">{{ alert.message }}</p>
                        <small class="text-muted">{{ formatRelativeTime(alert.timestamp) }}</small>
                      </div>
                      <i class="fas fa-check-circle ms-2" 
                         [class.text-success]="alert.acknowledged"
                         [class.text-muted]="!alert.acknowledged"></i>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="text-center p-4 text-muted" *ngIf="systemAlerts.length === 0">
                <i class="fas fa-shield-alt fa-2x mb-2"></i>
                <p class="mb-0">No system alerts yet</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Usage Instructions -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-info-circle me-2"></i>
                How to Use SignalR Demo
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <h6>Real-time Features</h6>
                  <ul class="mb-3">
                    <li><strong>Auto Connection:</strong> Automatically connects when authenticated</li>
                    <li><strong>Auto Reconnection:</strong> Handles connection drops gracefully</li>
                    <li><strong>Message Types:</strong> Notifications, order updates, system alerts</li>
                    <li><strong>Real-time Updates:</strong> See messages instantly as they arrive</li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <h6>Demo Controls</h6>
                  <ul class="mb-3">
                    <li><strong>Auto Demo:</strong> Generates random messages automatically</li>
                    <li><strong>Custom Messages:</strong> Send specific message types</li>
                    <li><strong>Test Functions:</strong> Generate sample data for testing</li>
                    <li><strong>Message Log:</strong> View detailed message history</li>
                  </ul>
                </div>
              </div>
              
              <div class="alert alert-info">
                <i class="fas fa-lightbulb me-2"></i>
                <strong>Tip:</strong> Open multiple browser tabs to see real-time message broadcasting between sessions. 
                Messages sent from one tab will appear in all connected tabs instantly.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>